const focusInput = (
  target: HTMLElement,
  getNextElement: (el: HTMLElement) => HTMLElement | null,
): void => {
  const nextElement = getNextElement(target) as HTMLInputElement | null;

  if (nextElement) {
    nextElement.focus();
  }
};

export const focusToNextInput = (target: HTMLElement): void =>
  focusInput(target, (el) => el.nextElementSibling as HTMLElement | null);

export const focusToPrevInput = (target: HTMLElement): void =>
  focusInput(target, (el) => el.previousElementSibling as HTMLElement | null);

const RE_DIGIT = new RegExp(/^\d+$/);

export const isDigit = (value: string): boolean => RE_DIGIT.test(value);
